import { render, staticRenderFns } from "./SideProgress.vue?vue&type=template&id=2d0c55d2&scoped=true"
import script from "./SideProgress.vue?vue&type=script&lang=js"
export * from "./SideProgress.vue?vue&type=script&lang=js"
import style0 from "./SideProgress.vue?vue&type=style&index=0&id=2d0c55d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0c55d2",
  null
  
)

export default component.exports